module.exports = __webpack_public_path__ + "img/p-sec01-img16.992531b5.png";